import React from 'react';
import {useDispatch} from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import './AppModalDialog.css';
import {getQueryElement} from '../../utils/queryElement';
import {closeModal} from '../../utils/tier-3-modal-close/PrequalCloseEvent';

function AppModalDialog({content, customerData, isMaintanence = false}) {
  const dispatch = useDispatch();
  return (
    <Modal
      id={!customerData.isDealerHostApplication.value ? 'app-modal-dialog' : 'tier3-modal-dialog'}
      show={isMaintanence || customerData.showModalFlag.value}
      onHide={() => closeModal(dispatch, customerData)}
      size='lg'
      container={getQueryElement(customerData).querySelector('#prequal-prefix')}
    >
      <Modal.Body data-testid='modal-body'>
        <div className={!customerData.isDealerHostApplication.value ? 'modal-dialog-content' : ''}>{content()}</div>
      </Modal.Body>
    </Modal>
  );
}

export default AppModalDialog;
